"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAList = void 0;
const echain_shared_logging_1 = require("@igus/echain-shared-logging");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const ArticleList_1 = require("../ArticleList");
const ArticleUtils_1 = require("../ArticleUtils");
const IA_1 = require("./IA");
const IAValidator_1 = require("./IAValidator");
const RolEchainUtils_1 = require("../rolEchain/RolEchainUtils");
const IaBeatUtil_1 = require("./IaBeatUtil");
const IaCountUtil_1 = require("./IaCountUtil");
const echain_product_models_1 = require("@igus/echain-product-models");
/**
 * The `IAList` manages a list of `IA`
 */
class IAList extends ArticleList_1.ArticleList {
    static fromScratch() {
        return new IAList();
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const list = new IAList();
        list.fromJson(json, cloneStrategy);
        return list;
    }
    static fromModel(model) {
        const list = new IAList();
        list.fromModel(model);
        return list;
    }
    static fromArray(arr) {
        const list = new IAList();
        list.fromArray(arr);
        return list;
    }
    fromJson(json, cloneStrategy = 'deep') {
        const items = json.map((j) => IA_1.IA.fromJson(j, cloneStrategy));
        // @ts-ignore
        this.items = items;
        this.model = this.items.map((i) => i.toModel());
        this.emitChange();
    }
    fromModel(model) {
        const items = model.map((m) => IA_1.IA.fromModel(m));
        // @ts-ignore
        this.items = items;
        this.model = model;
        this.emitChange();
    }
    clone() {
        return IAList.fromArray(this.items.map((i) => i.clone()));
    }
    toJson() {
        return this.items.map((i) => i.toJson());
    }
    toModel() {
        return this.model;
    }
    /*
     * Retrieves a new IAList filtered by Kette
     * @returns A new IAList
     */
    filterByKette(kette, options = {
        filterByBreite: false,
        smartPlasticOnly: false,
    }) {
        var _a, _b, _c;
        const ketteModel = kette.toModel();
        const ketteSerieRefId = (_c = (_b = (_a = ((0, echain_shared_articles_1.isRolEchainUnion)(ketteModel) ? RolEchainUtils_1.RolEchainUtils.getLinkForIaFilling(ketteModel) : ketteModel)) === null || _a === void 0 ? void 0 : _a.SerieRef) === null || _b === void 0 ? void 0 : _b.Id) !== null && _c !== void 0 ? _c : 0;
        const ias = this.toArray();
        const filteredIAList = new IAList();
        for (const ia of ias) {
            // skip if we know that kette does not support IAs breite
            if (options.filterByBreite && kette.supportsIABreite(ia.breite, ia.artikeltyp, ia.ketteSerieRef) === false) {
                continue;
            }
            // skip ia if smartPlasticOnly true and ia is not SmartPlasticsSeparator
            if (options.smartPlasticOnly && ia.artikeltyp !== echain_product_models_1.IAArtikeltyp.SmartPlasticsSeparator) {
                continue;
            }
            // add if ia has direct ref to kette
            if (ia.ketteRef && kette.id && ia.ketteRef.includes(kette.id)) {
                filteredIAList.add(ia);
            }
            // add if ia has indirect ref to kette using the ketteSerie
            else if (ketteSerieRefId && ia.ketteSerieRef) {
                for (const iaKetteSerieRef of ia.ketteSerieRef) {
                    if (iaKetteSerieRef && iaKetteSerieRef.id === ketteSerieRefId) {
                        filteredIAList.add(ia);
                    }
                }
            }
        }
        return filteredIAList;
    }
    filterByLink(linkModel, options = { filterByBreite: false }) {
        var _a;
        const linkSerieRefId = (_a = linkModel.SerieRef) === null || _a === void 0 ? void 0 : _a.Id;
        const iaModelArray = this.toModel();
        const filteredIaModelArray = iaModelArray.filter((iaModel) => {
            // skip if no KetteRef and no KetteSerieRef set on ia
            if (!(iaModel.KetteRef && iaModel.KetteSerieRef))
                return false;
            // skip if we know that kette does not support IAs breite
            if (options.filterByBreite && IA_1.IA.fromModel(iaModel).fitsInLink(linkModel) === false) {
                return false;
            }
            // return if ia has direct ref to kette
            if (linkModel.Id && iaModel.KetteRef.includes(linkModel.Id)) {
                return true;
            }
            // return if ia has indirect ref to kette using the ketteSerie
            if (linkSerieRefId) {
                return iaModel.KetteSerieRef.find((iaKetteSerieRef) => {
                    return iaKetteSerieRef.Id === linkSerieRefId;
                });
            }
            // no match
            return false;
        });
        return IAList.fromModel(filteredIaModelArray);
    }
    /**
     * Groups equal articles together.
     */
    group(options) {
        return ArticleUtils_1.ArticleUtils.groupArticles(this.items, options);
    }
    /**
     * Groups equal articles together ignoring properties for Innenaufteilung.
     */
    groupIgnoringIAProperties() {
        return this.group({
            ignoreProperties: ['_iaIndex', 'localTransform', 'dataSource', 'freigabeEIC'],
        });
    }
    /**
     * Groups IAs by ArtNr.
     */
    groupByArtNr() {
        return ArticleUtils_1.ArticleUtils.groupArticles(this.items, {
            comparator: (ia1, ia2) => ia1.getQuoteArtNr() === ia2.getQuoteArtNr(),
        });
    }
    /**
     * Groups IAs by ArtNr and IaBeat.
     */
    groupByArtNrInSameBeat({ sortBy }) {
        const groups = ArticleUtils_1.ArticleUtils.groupArticles(this.items, {
            comparator: (ia1, ia2) => ia1.getQuoteArtNr() === ia2.getQuoteArtNr() && IaBeatUtil_1.IaBeatUtil.areInSync(ia1.toModel(), ia2.toModel()),
        });
        if (sortBy === 'none') {
            return groups;
        }
        return groups.sort((g1, g2) => {
            var _a, _b;
            const ia1 = g1.article;
            const ia2 = g2.article;
            const ia1StartingAt = ia1.startingAtNthKettenglied || 0;
            const ia2StartingAt = ia2.startingAtNthKettenglied || 0;
            // primary: sort by startingAt
            if (ia1StartingAt < ia2StartingAt) {
                return -1;
            }
            if (ia1StartingAt > ia2StartingAt) {
                return +1;
            }
            // secondary: sort by artNr
            return (((_a = g1.article) === null || _a === void 0 ? void 0 : _a.getQuoteArtNr()) || '') < (((_b = g2.article) === null || _b === void 0 ? void 0 : _b.getQuoteArtNr()) || '') ? -1 : 1;
        });
    }
    /**
     * @returns the total weight of all ia items in chain
     */
    getCumulatedWeight(kette) {
        const weight_kg = this.items.reduce((cumulatedWeight, ia) => {
            var _a, _b;
            if (!((_a = ia.gewicht) === null || _a === void 0 ? void 0 : _a.kg))
                return cumulatedWeight;
            const count = (_b = IaCountUtil_1.IaCountUtil.getCountForKette(ia, kette.toModel(), (0, echain_shared_logging_1.getLogger)())) !== null && _b !== void 0 ? _b : 0;
            return cumulatedWeight + ia.gewicht.kg * count;
        }, 0);
        return echain_shared_quantities_1.Weight.kg(weight_kg);
    }
    /**
     * @returns the total weight of all ia items in rolEchain
     */
    getCumulatedWeightforRolEchain(rolEchain) {
        const weight_kg = this.items.reduce((cumulatedWeight, ia) => {
            var _a, _b;
            if (!((_a = ia.gewicht) === null || _a === void 0 ? void 0 : _a.kg))
                return cumulatedWeight;
            const count = (_b = IaCountUtil_1.IaCountUtil.getCountForKette(ia, rolEchain)) !== null && _b !== void 0 ? _b : 0;
            return cumulatedWeight + ia.gewicht.kg * count;
        }, 0);
        return echain_shared_quantities_1.Weight.kg(weight_kg);
    }
    /**
     * returns array of numbers there the index of the position in array match to the Gliednumber of
     * Kette and the value of this position returns the number of IAs in this Glied
     */
    getListWithNumberOfIAsPerGlied(kette) {
        if (this.hasAnyManualCountInput())
            return undefined;
        const numIasPerGlied = [];
        this.items.forEach((ia) => {
            const listWhichGliedHasIA = IaBeatUtil_1.IaBeatUtil.getListWhichGliedHasIA(ia, kette);
            listWhichGliedHasIA === null || listWhichGliedHasIA === void 0 ? void 0 : listWhichGliedHasIA.forEach((gliedHasIas, idx) => {
                var _a;
                (_a = numIasPerGlied[idx]) !== null && _a !== void 0 ? _a : (numIasPerGlied[idx] = 0);
                if (gliedHasIas) {
                    numIasPerGlied[idx] += 1;
                }
            });
        });
        return numIasPerGlied;
    }
    /**
     * returns true if any IA add manual count else false
     */
    hasAnyManualCountInput() {
        return this.items.some((ia) => ia.manualCount != null);
    }
    /**
     * Retrieves whether at least one IA has a count issue.
     */
    hasAnyCountIssue(kette) {
        return this.items.some((ia) => IAValidator_1.IAValidator.validateCountForKette(ia, kette).hasIssues());
    }
    /**
     * Recover IA state by trying to change startingAtNthKettenglied
     * 1 => 2
     * 2 => 1
     * 3 => 2
     * 4 => 3
     * ... (always -1)
     */
    fixCountIssues(kette) {
        if (!this.hasAnyCountIssue(kette))
            return true;
        this.items.forEach((ia) => {
            if (ia.startingAtNthKettenglied) {
                ia.startingAtNthKettenglied =
                    ia.startingAtNthKettenglied > 1 ? ia.startingAtNthKettenglied - 1 : ia.startingAtNthKettenglied + 1;
            }
        });
        return !this.hasAnyCountIssue(kette);
    }
    /**
     * Returns a new list with IAList filtered by set ArtNrCountry.
     */
    filterByArtNrCountry(artNrCountry) {
        return IAList.fromArray(this.items.filter((article) => article.localizedArtNr && article.localizedArtNr[artNrCountry]));
    }
    /**
     * Returns only those Ias which can be placed inside a Kette
     */
    filterPlaceableIas() {
        return IAList.fromArray(this.items.filter((ia) => ia.isPlaceable()));
    }
    getFlexWidthGroups() {
        const groups = [];
        const iaGroupMap = new Map();
        this.items.forEach((ia) => {
            var _a;
            if (ia.isFlexWidth()) {
                // populate the group map having multiple IAs in different width
                const artNrPart = echain_shared_articles_1.ArticleArtNrUtils.trimAfterFirstSeparator(ia.artNr);
                if (!iaGroupMap.has(artNrPart)) {
                    iaGroupMap.set(artNrPart, []);
                }
                (_a = iaGroupMap.get(artNrPart)) === null || _a === void 0 ? void 0 : _a.push(ia);
            }
            else {
                // directly push those not having flexible width
                groups.push([ia]);
            }
        });
        // now, after having collected all IAs with flexible width, push them into the result array
        iaGroupMap.forEach((v) => {
            groups.push(v);
        });
        return groups;
    }
    sortByIAIndex() {
        this.items.sort((a, b) => {
            var _a, _b;
            if (!a && !b)
                return 0;
            if (!a)
                return 1;
            if (!b)
                return -1;
            return ((_a = a.getIAIndexAsNumber()) !== null && _a !== void 0 ? _a : 0) - ((_b = b.getIAIndexAsNumber()) !== null && _b !== void 0 ? _b : 0);
        });
        return this;
    }
    add(ia) {
        super.add(ia);
        this.updateIaIndices();
    }
    update(ia) {
        super.update(ia);
        this.updateIaIndices();
    }
    remove(ia) {
        super.remove(ia);
        this.updateIaIndices();
    }
    updateIaIndices() {
        let index = 1;
        const verticalIAs = this.items.filter((ia) => ia.isVertical());
        const horizontalIAs = this.items.filter((ia) => ia.isHorizontal());
        const spacerIAs = this.items.filter((ia) => ia.isAbstandhalter());
        const universalSeparatorIAs = this.items.filter((ia) => ia.isUniversalSeparator());
        verticalIAs.forEach((ia) => {
            ia.setIAIndex(index++);
        });
        horizontalIAs.forEach((ia) => {
            ia.setIAIndex(index++);
        });
        spacerIAs.forEach((ia) => {
            ia.setIAIndex(index++);
        });
        universalSeparatorIAs.forEach((ia) => {
            ia.setIAIndex(index++);
        });
    }
    getMinAussenbreite() {
        return this.items.reduce((minWidth, curr) => { var _a, _b; return Math.min(minWidth, (_b = (_a = curr.aussenbreite) === null || _a === void 0 ? void 0 : _a.mm) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER); }, Number.MAX_SAFE_INTEGER);
    }
}
exports.IAList = IAList;
//# sourceMappingURL=IAList.js.map